import { type, Schema, MapSchema, ArraySchema } from '@colyseus/schema';
import { Guess } from './Location';

// Coop mode roles
export enum CoopRole {
    NONE = "none",
    PHOTOSPHERE = "photosphere", // Can see the photosphere, must describe to teammate
    MAP = "map" // Can see the map, must guess based on teammate's description
}

export class Player extends Schema {
    @type("string") name: string = '';
    @type("string") avatarId: string = '';
    @type("string") uniqueId: string = ''; // Unique identifier for reconnection (name + avatarId hash)
    @type("string") teamId: string = ''; // Empty string means no team assigned
    @type("boolean") hasGuessed: boolean = false;
    @type("boolean") isReady: boolean = false;
    @type("boolean") inLobby: boolean = false; // Individual player lobby status
    @type({map: Guess}) guesses = new MapSchema<Guess>();
    @type(Guess) tentativeGuess = new Guess(); // Stores unconfirmed guess that can be auto-submitted
    @type(["number"]) scores = new ArraySchema<number>();
    @type("number") totalScore: number = 0;
    @type("number") playerNumber: number = 0; // Persistent player number starting from 1
    @type("boolean") isEliminated: boolean = false; // For Endless mode elimination
    @type("number") currentStreak: number = 0; // For Endless mode streak tracking
    @type("string") coopRole: CoopRole = CoopRole.NONE; // For Coop mode: which role the player has this round
    @type("boolean") photosphereLoaded: boolean = false; // For tracking if player has loaded the current photosphere

    constructor() {
        super();
        this.name = Player.generateRandomName();
    }

    static generateRandomName(): string {
        const randomNumber = Math.floor(1000 + Math.random() * 9000);
        return `Guest of Light ${randomNumber}`;
    }

    static generateUniqueId(name: string, avatarId: string): string {
        // Simple hash function to create a consistent unique ID
        const combinedStr = `${name}:${avatarId}`;
        let hash = 0;
        for (let i = 0; i < combinedStr.length; i++) {
            const char = combinedStr.charCodeAt(i);
            hash = ((hash << 5) - hash) + char;
            hash = hash & hash; // Convert to 32-bit integer
        }
        return Math.abs(hash).toString(36);
    }
}